import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@ridgewill/brand/tokens.css';
/**
 * The base stylesheet, and importing it is not a formality: without it nothing
 * sets `font-family` at document level and the whole portal renders in the
 * browser's default serif. tokens.css declares custom properties and applies
 * none of them, which is why its presence hid the gap. See styles.css.
 */
import './styles.css';
/**
 * REQUIRED by `CodeInput`, unlike `@ridgewill/brand/tokens.css` which is
 * optional by design — its `var()` fallbacks mean forgetting it is harmless.
 * These two rules cannot be style objects, and without them the code field
 * still renders: it just highlights boxes that look empty when the value is
 * selected, and shows a caret that does not blink.
 */
import '@ridgewill/brand/code-input.css';
import { App } from './App.js';
import { connectionPageFor } from './lib/connections.js';
import { supportSession } from './lib/support-token.js';

/**
 * A product's old link to one person's ROW, `/connections#connection-<id>`,
 * now opens that person's page (account#79). Done before anything renders so
 * the app routes on the new path, and with `replaceState` so Back does not
 * return to a link that would only forward again.
 */
const forwarded = connectionPageFor(window.location.pathname, window.location.hash);
if (forwarded) window.history.replaceState(null, '', forwarded);

/**
 * A support sign-in round trip lands on `/callback` (lib/support-token.ts), and
 * is finished BEFORE the first render, which puts the address back to the page
 * it started on. It never throws; a failure is reported by the Support screen.
 */
await supportSession.completeCallback();

const root = document.getElementById('root');
if (!root) throw new Error('#root is missing from index.html');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
